import { spacing, color } from '@upstox/upstox-ui';

export const preApplyWrapper: CSSFunction = ({ theme }) => ({
  marginBottom: spacing(theme, ['medium']),
  '@media(min-width:768px)': {
    marginBottom: spacing(theme, [44]),
  },
});

export const fullWidth: CSSFunction = () => ({
  width: '100% !important',
});
